(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gilt-promo-offer"] && !Shopify.designMode) return;
  try {
    /* One delegated listener for every promo line on the page, bound once.
     Delegation also means a line re-rendered by the theme editor keeps
     working without rebinding. */
  (function () {
    var BUSY = 'aria-busy';

    function cartUrl() {
      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/$/, '') + '/cart/update.js';
    }

    /* Reads the response cart back to find out what really happened.
       update.js answers 200 even when a code is refused, so the cart it
       returns is the only honest signal.

       The one thing not to read too much into is `applicable`. It does not
       mean "refused", it means "not reducing anything right now" — which is
       also true of a perfectly good code sitting on an empty cart, since
       there is no line for it to price yet. Shopify still stores it, and it
       comes out at checkout. Treating that as a failure is what used to put
       an error under a code that had in fact been applied.

       So: being echoed back at all is what counts as accepted. Only a code
       that is absent, or one that is inapplicable while the cart does have
       items to price, is reported as refused. */
    function statusFor(cart, code) {
      /* 200 with a body that cannot be read: the request did succeed, so do
         not accuse it of failing. */
      if (!cart || typeof cart !== 'object') return 'applied';
      if (!Array.isArray(cart.discount_codes)) return 'applied';

      var wanted = String(code).toLowerCase();
      var entry = null;

      for (var i = 0; i < cart.discount_codes.length; i++) {
        var candidate = cart.discount_codes[i] || {};
        if (String(candidate.code || '').toLowerCase() === wanted) {
          entry = candidate;
          break;
        }
      }

      if (!entry) return 'rejected';
      if (entry.applicable !== false) return 'applied';

      /* Stored, but pricing nothing yet. Only call that a refusal when the
         cart actually had something for it to discount. */
      return cart.item_count > 0 ? 'rejected' : 'pending';
    }

    function setApplied(root) {
      root.classList.add('is-applied');
      var button = root.querySelector('[data-gilt-apply-offer]');
      if (button) button.disabled = true;
      var error = root.querySelector('[data-gilt-promo-error]');
      if (error) error.hidden = true;
    }

    function setError(root) {
      root.classList.remove('is-applied');
      var error = root.querySelector('[data-gilt-promo-error]');
      if (error) error.hidden = false;
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest
        ? event.target.closest('[data-gilt-apply-offer]')
        : null;
      if (!button || button.disabled) return;

      var root = button.closest('[data-gilt-promo]');
      if (!root) return;

      var code = root.getAttribute('data-promo-code');
      if (!code) return;

      event.preventDefault();

      button.setAttribute(BUSY, 'true');
      var error = root.querySelector('[data-gilt-promo-error]');
      if (error) error.hidden = true;

      fetch(cartUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ discount: code })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart responded ' + response.status);
          return response.json();
        })
        .then(function (cart) {
          var status = statusFor(cart, code);

          if (status === 'rejected') {
            setError(root);
            return;
          }

          setApplied(root);

          /* The cart changed, so anything showing it should catch up. */
          document.dispatchEvent(
            new CustomEvent('gilt:promo:applied', {
              bubbles: true,
              detail: { code: code, cart: cart, pending: status === 'pending' }
            })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          setError(root);
        })
        .then(function () {
          button.removeAttribute(BUSY);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
